import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";
import { useAuth } from "../../../AuthContext";
import { useSetUserRegisterMutation } from "../../../redux/user";

const SignUp = () => {
  const { login } = useAuth();
  const [setUserRegister] = useSetUserRegisterMutation();
  const [initialValues, setInitialValues] = useState({
    fullName: "",
    email: "",
    mobile_number: "44",
    terms: false,
    country_code: "",
    number: "",
  })
  const validationSchema = Yup.object().shape({
    fullName: Yup.string()
    .required("Full Name is required")
    .test(
      "no-leading-space",
      "Full Name cannot start with a space",
      (value) => value && !value.startsWith(" ")
    ),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    mobile_number: Yup.string().required("Mobile number is required"),
    terms: Yup.boolean().oneOf([true], "You must accept the terms"),
  });

  const handleSubmit = (value) => {
    if (!localStorage.getItem("wallet_address")) {
      toast.dismiss();
      toast.error("Please connect your wallet");
      window.location.href = "/";
      return;
    }
    if (value.number === "") {
      toast.dismiss();
      toast.error("Please enter mobile number");
      return false;
    }
    const data = {
      name: value.fullName,
      email: value.email,
      mobile_number: value.number,
      country_code: value.country_code,
      wallet_address: localStorage.getItem("wallet_address"),
    };
    setUserRegister(data).then((result) => {
      if (result.data.status) {
        login();
        setInitialValues({
          fullName: "",
          email: "",
          mobile_number: "44",
          terms: false,
          country_code: "",
          number: "",
        })
        localStorage.setItem("token", result.data.token);
        toast.dismiss();
        toast.success(result.data.message);
        window.location.href = "/";
      } else {
        toast.dismiss();
        toast.error(result.data.message);
      }
    });
  };

  return (
    <section className="signup position-relative">
      <div className="text-center"></div>
      <div className="container">
        <div className="row">
          <div className="col-md-10 m-auto">
            <div className="row">
              <div className="col-md-6 bl br bb p-0">
                <div className="siup_box p-4">
                  <small className="color1 fw300 ttu" data-aos="fade-up">
                    Sign up now to get your free $SCOTTY tokens!
                  </small>
                  <h2 className="hadding mb-4 mt-3">
                    Claim your free{" "}
                    <span className="color1">$SCOTTY Token</span>
                  </h2>

                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                      handleSubmit(values);
                    }}
                  >
                    {({ values, setFieldValue, errors, touched }) => (
                      <Form>
                        {/* Full Name */}
                        <div className="form-group ex_input_box position-relative">
                          <label className="mb-2">Full Name</label>
                          <Field
                            type="text"
                            name="fullName"
                            placeholder="Please enter your full name"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="fullName"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        {/* Email */}
                        <div className="form-group ex_input_box position-relative">
                          <label className="mb-2">
                            Enter your Email Address
                          </label>
                          <Field
                            type="text"
                            name="email"
                            placeholder="example@email.com"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        {/* Phone Number */}
                        <div className="form-group ex_input_box position-relative">
                          <label className="mb-2">
                            Enter Your Phone Number
                          </label>
                          <PhoneInput
                            country="IND"
                            value={values.mobile_number}
                            onChange={(value, country) => {
                              setFieldValue("mobile_number", value);
                              setFieldValue(
                                "country_code",
                                `+${country.dialCode}`
                              ); // Store country code
                              let adjustedMobile = value?.startsWith(
                                country.dialCode
                              )
                                ? value.replace(country.dialCode, "")
                                : value;
                              setFieldValue("number", adjustedMobile); // Store country code
                            }}
                            className="input_item2"
                            placeholder="Enter Mobile Number"
                            countryCodeEditable={false}
                            enableSearch={true}
                            inputProps={{
                              name: "mobile_number",
                            }}
                          />
                          {errors.mobile_number && touched.mobile_number && (
                            <div className="text-danger">
                              {errors.mobile_number}
                            </div>
                          )}
                        </div>

                        {/* Terms and Conditions */}
                        <div className="form-group ex_input_box position-relative">
                          <div className="form-check">
                            <Field
                              className="form-check-input"
                              type="checkbox"
                              name="terms"
                              id="flexCheckDefault"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexCheckDefault"
                            >
                              I accept the{" "}
                              <Link to="/">Terms and Conditions</Link>
                            </label>
                          </div>
                          <ErrorMessage
                            name="terms"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        {/* Submit Button */}
                        <button
                          type="submit"
                          className="btn btn_bg pe-5 ps-5 ttu"
                        >
                          Submit
                        </button>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
              <div className="col-md-6 br bb p-0">
                <img
                  src="/assets/img/signupimg.jpg"
                  alt="f11"
                  className="w100"
                  data-aos="fade-left"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignUp;
